import * as yup from "yup";

export const emailSchema = yup
  .object({
    name: yup.string().required("Name is required").default(""),
    subject: yup.string().required("Subject is required").default(""),
    // null means "start blank".
    template_id: yup.string().nullable().default(null),
  })
  .required();
